import { tss } from 'tss-react/mui';

export const useTransitionStyles = tss.withName('TransitionSection').create(({ theme }) => ({
    section: {
        backgroundColor: theme.palette.ink.main,
        color: theme.palette.ink.contrastText,
        padding: theme.spacing(14, '6%'),
    },
    inner: {
        maxWidth: '1400px',
        margin: '0 auto',
    },
    eyebrow: {
        color: theme.palette.primary.main,
        display: 'block',
        marginBottom: theme.spacing(2.5),
    },
    headline: {
        marginBottom: theme.spacing(8),
        maxWidth: 700,
    },
    visual: {
        width: '100%',
        height: 420,
        [theme.breakpoints.down('sm')]: {
            height: 300,
        },
    },
}));
